module.exports = __webpack_public_path__ + "media/promo/promo/images/card-2-89061da91259e040ff2b60d99fc50f6b.jpg";